import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const handleErrors = err => {
  if (!err.response || err.response.status === 500) {
    // break app
  }

  return err.response
}

const responseData = res => res && res.data

const requests = {
  del: url =>
    axios.delete(url)
      .catch(handleErrors)
      .then(responseData),
  get: url =>
    axios.get(url)
      .catch(handleErrors)
      .then(responseData),
  put: (url, body) => {
    axios.put(url, body)
      .catch(handleErrors)
      .then(responseData)
  },
  post: (url, body) => {
    axios.post(url, body)
      .catch(handleErrors)
      .then(responseData)
  }
}

const projects = {
  filters: () => requests.get('/en/portfolioWork/ListCategories/'),
  list: () => requests.get('/en/portfolioWork/ListPortfolio/'),
  details: id => requests.get(`/en/portfolioWork/GetPortfolio?id=${ id }`)
}

const home = {
  news: () => requests.get('/en/portfolioWork/ListHomepage/')
}

const team = {
  people: () => requests.get('/en/person/listPeople/')
}

const contact = {
  jobs: () => requests.get('/en/job/listJobs'),
  description: () => requests.get('/en/entry/getEntry?id=job_text')
}

const about = {
  customers: () => requests.get('/customer/ListCustomerCol'),
  customers1: () => requests.get('/customer/ListCustomerCol2')
}

export default { projects, team, contact, about, home }



// WEBPACK FOOTER //
// ./src/service.js